// extracted by mini-css-extract-plugin
module.exports = {"tenant-setting-panel":"tenant-setting-panel___1d4-x","metric-radio-group":"metric-radio-group___3zYmV","title-wrap":"title-wrap___ApSUc","bordered":"bordered___2YOQR"};